// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"98":"6376b4ed","195":"6851a4bd","466":"3936f9e4","482":"e1f7b6bb","580":"1c15f26e","753":"56823f58","855":"64def034","908":"e6654523","937":"eae5f325"}[chunkId] + ".chunk.css";
};